const sectionImageWithTextBasicCss = `
[data-type='section-image-with-text-basic'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-image-with-text-basic'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-image-with-text-basic'] h1,
[data-type='section-image-with-text-basic'] h2,
[data-type='section-image-with-text-basic'] h3,
[data-type='section-image-with-text-basic'] h4 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-image-with-text-basic'] .header-content {
  margin-bottom: 20px;
}

[data-type='section-image-with-text-basic'] .wrapper-content {
  padding: 16px;
  border-radius: 20px;
}

[data-type='section-image-with-text-basic'] .wrap-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

[data-type='section-image-with-text-basic'] .wrap-img img {
  display: block;
  margin: auto;
  width: var(--width-image, 100%);
  height: auto;
}

@container (max-width: 768px) {
  [data-type='section-image-with-text-basic'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-image-with-text-basic'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-image-with-text-basic'] h1,
  [data-type='section-image-with-text-basic'] h2,
  [data-type='section-image-with-text-basic'] h3,
  [data-type='section-image-with-text-basic'] h4 {
    font-size: 20px;
  }
}
`;
export default sectionImageWithTextBasicCss;
